<mf-page title="Detalles de la acreditación por cuenta">
  @if(accreditationsByAccount) {
  <mf-column-display label="Id">
    {{ accreditationsByAccount.id }}
  </mf-column-display>

  <mf-track-grid [id]="accreditationsByAccount.id" />
  }
</mf-page>
